import React from "react";
import Styles from "./style.module.scss";

interface RequestErrorProps {
  message: string;
  onRetry?: () => void;
}

export const RequestError: React.FC<RequestErrorProps> = ({ message, onRetry }) => (
  <div className={Styles.error} role="alert">
    <p>{message}</p>
    {onRetry && (
      <button type="button" onClick={onRetry}>
        Try again
      </button>
    )}
  </div>
);
